/**
 * Footer composite component exports
 *
 * Exports the Footer compound component for use throughout the application.
 * Footer uses a compound component pattern with sub-components (Footer.Top,
 * Footer.Bottom, Footer.Brand, etc.) for flexible composition.
 */
export {
  Footer,
  FooterTop,
  FooterBottom,
  FooterBrand,
  FooterSectionGroup,
  FooterSection,
  FooterLinks,
  type FooterProps,
} from './Footer';
export { footerVariants, type FooterVariantProps } from './footer.variants';
